module.exports = __webpack_public_path__ + "static/media/au-flag.7c8af3f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/au-flag.svg
// module id = 5286
// module chunks = 11